import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/Home'
// artist
import Artist from '@/views/artist/Artist.vue'
import Collection from '@/views/artist/Collection.vue'
//common
import Terms from '@/views/common/Terms.vue'
import PrivacyStatement from '@/views/common/PrivacyStatement.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home},
  { path: '/artsit/:author', name: 'Artist', component: Artist },
  { path: '/:title', name: 'Collection', component: Collection},
  { path: '/about/terms', name: 'Terms', component: Terms },
  { path: '/about/privacy', name: 'PrivacyStatement', component: PrivacyStatement },
]

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 切换页面滚动到页面顶部
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js